import { NotFoundError } from '../error/NotFoundError';

export function callbackToPromise<T>(fn: (onSuccess: (data: T) => void, onFail: (error?: any) => void) => void): Promise<T> {
    return new Promise((resolve, reject) => {
        fn(
            (data) => resolve(data),
            (error) => {
                if (error?.response?.status === 404) {
                    reject(new NotFoundError());
                } else {
                    reject(new Error('Request failed'));
                }
            },
        );
    });
}
